import { useCallback, useState } from 'react'
import { ColumnDef, createColumnHelper } from '@tanstack/react-table'

import TSTable from 'components/Tanstack'
import { useOffersStore } from 'store/offers'
import { useTableUtils } from 'hooks/useTableUtils'
import { OffersDataTypes, OffersModalActionsTypes } from 'types/offers'

export const useMemberOffersTable = () => {
  const offers = useOffersStore((state) => state.offers)

  const {
    selectedModal,
    selectedModalSet,
    selectedRowData,
    selectedRowDataSet,
  } = useTableUtils<OffersDataTypes, OffersModalActionsTypes>()

  const handleActionModalClose = useCallback(() => {
    selectedRowDataSet(null)
    selectedModalSet(null)
  }, [selectedModalSet, selectedRowDataSet])

  const [expandedOfferId, setExpandedOfferId] = useState<number | null>(null)

  const columnHelper = createColumnHelper<OffersDataTypes>()
  const columns = [
    columnHelper.accessor('offerId', {
      header: () => 'Offer ID',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('offerName', {
      header: () => 'Offer Name',
      cell: (info) => {
        const id = info.row.original.offerId
        const isExpanded = expandedOfferId === id

        return (
          <button
            type="button"
            className="flex flex-col text-left cursor-pointer"
            onClick={() => setExpandedOfferId(isExpanded ? null : id)}
          >
            <span>{info.getValue()}</span>
          </button>
        )
      }
    }),
    columnHelper.accessor('voucherName', {
      header: () => 'Voucher Name',
      cell: (info) => (
        <p className="flex flex-col">
          <span>{info.getValue()}</span>
          <span>{info.row.original.voucherCode}</span>
        </p>
      ),
    }),
    columnHelper.accessor('startDate', {
      header: () => 'Start Date',
      cell: (info) => <TSTable.TableCellDate date={info.getValue() || ''} />,
    }),
    columnHelper.accessor('endDate', {
      header: () => 'End Date',
      cell: (info) => <TSTable.TableCellDate date={info.getValue() || ''} />,
    }),
    columnHelper.display({
      id: 'actions',
      header: () => '',
      // cell: (info) => info.getValue(),
      cell: ({ row }) => (
        <div className="flex gap-2 px-4">
          {/* <TSTable.TableCellButton
            onClick={() => {
              selectedOffersSet(row.original)
              selectedActionModalSet('preview')
            }}
            label="Preview"
            icon={faEye}
          /> */}
        </div>
      ),
    }),
  ] as ColumnDef<OffersDataTypes>[]

  return {
    memberOffersSelected: selectedRowData,
    memberOffersActionModal: selectedModal,
    memberOffersTableData: offers,
    memberOffersTableColumns: columns,
    handleMemberActionModalClose: handleActionModalClose,
    expandedOfferId,
    setExpandedOfferId,
  }
}
